import { render } from "./Genre.vue?vue&type=template&id=52ee40bc"
import script from "./Genre.vue?vue&type=script&lang=js"
export * from "./Genre.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__